import React from 'react';

const Service = (props) => (
	<div className="service">
        <h4 className="m-2 text-center">{props.text}</h4>
    </div>
)

export default Service;